import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar.js";
import AdminFooter from "./AdminFooter.js";
import AdminHeader from "./AdminHeader.js";
import {
  server_post_data,
  save_update_testimonial,
  get_all_testimonial,
} from "../../ServiceConnection/serviceconnection.js";
import {
  check_vaild_save,
  combiled_form_data,
  empty_form,
  handleAphabetsChange,
  handleIaphabetnumberChange,
  handleNumbersRatingChange,
  handleSuccessSession,
  handleError,
  handleNumbersChange,
} from "../../CommonJquery/CommonJquery.js";
import { useLocation, Link } from "react-router-dom";
import { retrieveData } from "../../LocalConnection/LocalConnection.js";
function TestimonialDashboardAdd() {
  const location = useLocation();
  const currentUrl = location.pathname.substring(1);
  const [editorDataMainID, setEditorDatMainID] = useState("0");
  const [editBlogData, seteditBlogData] = useState([]);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const retrievedAdminId = retrieveData("staff_id");
  useEffect(() => {
    const url = currentUrl;
    const parts = url.split("/");
    if (parts.length !== 1) {
      const start_date = "";
      const end_date = "";
      const flag = "3";
      const call_id = parts[1];
      master_data_get(start_date, end_date, flag, call_id);
    }
  }, []);

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("admin_id", retrievedAdminId);
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    await server_post_data(get_all_testimonial, fd)
      .then((Response) => {
        console.log(Response.data);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          seteditBlogData(Response.data.message.data_testimonial[0]);
          setEditorDatMainID(
            Response.data.message.data_testimonial[0].primary_id
          );
          setDynaicimage(
            Response.data.message.data_testimonial[0].testimonial_images
          );
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
      });
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    if (vaild_data) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      fd_from.append("admin_id", retrievedAdminId);
      fd_from.append("main_id", editorDataMainID);
      fd_from.append("old_image_link", dynaicimage);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          console.log(Response.data.message);
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            handleSuccessSession(
              Response.data.message,
              "/testimonialDashboardView"
            );
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
        });
    }
  };
  const [dynaicimage, setDynaicimage] = useState(null);
  const handleFileChangedynamic = (keyname) => (event) => {
    const file = event.target.files[0];

    let new_file_name = keyname + "_show";

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        setDynaicimage((prevImages) => ({
          ...prevImages,
          [keyname]: file,
          [new_file_name]: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setDynaicimage((prevImages) => ({
        ...prevImages,
        [keyname]: null,
        [new_file_name]: null,
      }));
    }
  };
  return (
    <div className="app-container app-theme-white body-tabs-shadow fixed-header">
      <div className={showLoaderAdmin ? "loading_website" : ""}></div>
      <AdminHeader />

      <div className="app-main">
        <AdminSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner">
            <div className="app-page-title">
              <div className="page-title-wrapper">
                <div className="page-title-heading">
                  <Link to="/admindashboard">
                    <div className="page-title-icon">
                      <i className="fa fa-home icon-gradient bg-mean-fruit"></i>
                    </div>
                  </Link>
                  <div>
                    Website Management &gt; Testimonials
                    <div className="page-title-subheading">
                      Add and Edit Testimonials
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="main-card mb-3 card">
              <div className="card-body">
                <h5 className="card-title">Add/Edit Testimonial</h5>
                <form className="needs-validation" id="CarrerformData">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="validationCustom01">
                        Title<span className="red_show">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control  trio_mandatory"
                        name="testimonial_title"
                        id="testimonial_title"
                        maxLength={100}
                        onInput={handleIaphabetnumberChange}
                        placeholder="Enter Title"
                        defaultValue={editBlogData.testimonial_title || ""}
                      />
                      <span className="condition_error"></span>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="validationCustom01">
                        Name<span className="red_show">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control  trio_mandatory"
                        name="testimonial_name"
                        id="testimonial_name"
                        maxLength={35}
                        onInput={handleAphabetsChange}
                        placeholder="Enter Name"
                        defaultValue={editBlogData.testimonial_name || ""}
                      />
                      <span className="condition_error"></span>
                    </div>
                  </div>
                  <div className="row">
                    {/* <div className="col-md-3 mb-3">
                      <label htmlFor="validationCustom01">
                        Rating<span className="red_show">*</span>(Ex. 2.0, 2.5)
                      </label>
                      <input
                        type="text"
                        className="form-control  trio_mandatory"
                        name="testimonial_rating"
                        id="testimonial_rating"
                        maxLength={3}
                        onInput={handleNumbersRatingChange}
                        placeholder="Enter rating"
                        defaultValue={editBlogData.testimonial_rating || ""}
                      />
                      <span className="condition_error"></span>
                    </div> */}
                    <div className="col-md-9 mb-3">
                      <label htmlFor="validationCustom01">
                        Details<span className="red_show">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control  trio_mandatory"
                        name="testimonial_details"
                        id="testimonial_details"
                        maxLength={150}
                        onInput={handleIaphabetnumberChange}
                        placeholder="Enter Details"
                        defaultValue={editBlogData.testimonial_details || ""}
                      />
                      <span className="condition_error"></span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="validationCustom01">
                        Images
                        <span style={{ color: "red", fontWeight: "600" }}>
                          (size 500 x 500 upto 500kb)
                        </span>
                      </label>
                      <br></br>
                      <input
                        style={{ marginBottom: "1rem" }}
                        className="inputEditFile"
                        type="file"
                        name="silder_image_name"
                        onChange={handleFileChangedynamic("silder_image_name")}
                        accept=".jpg,.jpeg,.png"
                      />
                      <div className="previewEditBox">
                        {dynaicimage && dynaicimage.silder_image_name_show && (
                          <img
                            src={dynaicimage.silder_image_name_show}
                            alt="Preview"
                            className="imgEditMaster"
                          />
                        )}
                      </div>
                      <span className="condition_error"></span>
                    </div>
                  </div>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() =>
                      handleSaveChangesdynamic(
                        "CarrerformData",
                        save_update_testimonial
                      )
                    }
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
          <AdminFooter />
        </div>
      </div>
    </div>
  );
}
export default TestimonialDashboardAdd;
